export type TalentPaymentStatus = 'not_started' | 'processing' | 'action_required' | 'paid';
export type OfficePaymentStatus = 'processing' | 'action_required' | 'paid';

export function getTalentPaymentStatusCopy(
  status?: TalentPaymentStatus | null,
  method?: 'instant' | 'standard' | null,
  officeStatus?: OfficePaymentStatus | null,
) {
  if (officeStatus === 'action_required') {
    return {
      title: 'Office Payment Needs Attention',
      detail: 'The office payment has not been confirmed. TempStars Payments is reviewing it, and the talent payout has not started.',
      tone: 'attention' as const,
    };
  }
  if (officeStatus === 'processing') {
    return {
      title: 'Office Payment Processing',
      detail: 'The office payment is still processing. The talent payout will start only after the office payment succeeds.',
      tone: 'processing' as const,
    };
  }

  switch (status) {
    case 'paid':
      return {
        title: '✓ Talent Payment Confirmed',
        detail: 'The office payment and the talent payout are both complete.',
        tone: 'success' as const,
      };
    case 'action_required':
      return {
        title: 'Office Payment Received',
        detail: 'The talent payout needs attention from TempStars Payments. You do not need to pay again.',
        tone: 'attention' as const,
      };
    case 'not_started':
      return {
        title: 'Office Payment Received',
        detail: 'The office payment was received, but the talent payout has not started yet. TempStars Payments will process it next; you do not need to pay again.',
        tone: 'processing' as const,
      };
    case 'processing':
      return {
        title: 'Office Payment Received',
        detail: method === 'instant'
          ? 'The talent instant payout is processing and typically reaches their bank account within 30 minutes, though some banks can take longer. You do not need to pay again.'
          : method === 'standard'
            ? 'The talent standard payout is processing and typically reaches their bank account within 1–4 business days. You do not need to pay again.'
            : 'The talent payout is processing. You do not need to pay again.',
        tone: 'processing' as const,
      };
    default:
      return null;
  }
}
